import { saveUtilityCache } from '../../../utils/utilityAppStorage';
import { create } from 'zustand';
import { formatISO } from 'date-fns';

// Cargar dato inicial del localStorage
const getInitialProgressState = () => {
  try {
    const stored = localStorage.getItem('fitnessData');
    if (!stored) {
      return {
        measurements: [],
        workoutStreak: 0,
        lastWorkoutDate: null,
      };
    }
    const data = JSON.parse(stored);
    if (!data.progress) {
      return {
        measurements: [],
        workoutStreak: 0,
        lastWorkoutDate: null,
      };
    }
    return {
      measurements: data.progress.measurements || [],
      workoutStreak: data.progress.workoutStreak || 0,
      lastWorkoutDate: data.progress.lastWorkoutDate || null,
    };
  } catch (e) {
    console.error('Error loading progress:', e);
    return {
      measurements: [],
      workoutStreak: 0,
      lastWorkoutDate: null,
    };
  }
};

// Helper para guardar en localStorage unificado
const saveToLocalStorage = (state) => {
  try {
    const current = localStorage.getItem('fitnessData');
    const allData = current ? JSON.parse(current) : {};
    allData.progress = {
      measurements: state.measurements,
      workoutStreak: state.workoutStreak,
      lastWorkoutDate: state.lastWorkoutDate,
    };
    saveUtilityCache('fitnessData', allData);
  } catch (e) {
    console.error('Error saving progress:', e);
  }
};

const initialState = getInitialProgressState();

export const useProgressStore = create((set, get) => ({
  measurements: initialState.measurements,
  workoutStreak: initialState.workoutStreak,
  lastWorkoutDate: initialState.lastWorkoutDate,

  addMeasurement: (data) =>
    set((state) => {
      const newState = {
        ...state,
        measurements: [
          {
            id: Date.now().toString(),
            date: formatISO(new Date()),
            weight: data.weight || null,
            chest: data.chest || null,
            waist: data.waist || null,
            arms: data.arms || null,
            legs: data.legs || null,
            notes: data.notes || '',
          },
          ...state.measurements,
        ],
      };
      saveToLocalStorage(newState);
      return newState;
    }),

  deleteMeasurement: (id) =>
    set((state) => {
      const newState = {
        ...state,
        measurements: state.measurements.filter((m) => m.id !== id),
      };
      saveToLocalStorage(newState);
      return newState;
    }),

  getMeasurements: () => get().measurements,

  getLatestMeasurement: () => {
    const measurements = get().measurements;
    return measurements.length > 0 ? measurements[0] : null;
  },

  getWeightProgress: () => {
    const measurements = get().measurements
      .filter((m) => m.weight)
      .sort((a, b) => new Date(a.date) - new Date(b.date));
    return measurements;
  },

  updateStreak: (date) =>
    set((state) => {
      const last = state.lastWorkoutDate ? new Date(state.lastWorkoutDate) : null;
      const today = new Date(date);

      const diffDays = last
        ? Math.floor((today - last) / (1000 * 60 * 60 * 24))
        : 0;

      let newStreak = state.workoutStreak;
      if (diffDays === 1) {
        newStreak++;
      } else if (diffDays > 1) {
        newStreak = 1;
      }

      const newState = {
        ...state,
        workoutStreak: newStreak,
        lastWorkoutDate: date,
      };
      saveToLocalStorage(newState);
      return newState;
    }),

  getStreak: () => get().workoutStreak,
}));
